import {SENSITIVE_SCOPE} from "./securityContext";

export function getStepUpMaxAge(scope) {
    switch (scope) {
        case SENSITIVE_SCOPE.DELETE_ACCOUNT:
        case SENSITIVE_SCOPE.CHANGE_PASSWORD:
            return 0;

        case SENSITIVE_SCOPE.ENROLL_MFA:
        case SENSITIVE_SCOPE.UNENROLL_MFA:
            return 300;

        default:
            return 300;
    }
}